import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboard-pacientes',
  templateUrl: './dashboard-pacientes.component.html',
  styleUrls: ['./dashboard-pacientes.component.css']
})
export class DashboardPacientesComponent implements OnInit {
  hideCL: boolean = false;
  nomeCidade: any = '';
  qBuscado: any = '';
  tipoListar: any = '';
  arrResults: any[] = [];
  arrResultsG: any[] = [];
  urlFoto: any = '';
  indexBusca: any = 0;
  qtdResultados: any = 0;
  fraseExib: any = '';
  onDemand: boolean = false;
  parametroB: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { 
    route.params.subscribe(val =>{
      if(this.tmaService.hcEmail !== ''){
        this.funcaoInicial();
      }
      
    })

  }

  ngOnInit() {
    //this.hideCL = true;
    this.tmaService.eventoFS(true);
    //this.nomeCidade = this.route.snapshot.paramMap.get('cidade');
    //padrões: todos, ultimos, listar (pesquisa)
    
    //listar: nome, email ou telefone
    
    //this.arrResults.push({qq: 1});
    
    
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  funcaoInicial() :void{
    this.tipoListar =  this.route.snapshot.paramMap.get('tipo');
    this.qBuscado = this.route.snapshot.paramMap.get('parametrobusca');
    if(this.tipoListar == 'all'){
      this.obterResultados();
    }
    else{
      this.obterResultadosP();
    }
  }

  obterResultados() :void{
    //this.tipoListar =  this.route.snapshot.paramMap.get('tipo');
    
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipopesquisa=' + this.tipoListar + '&parametro=' + this.qBuscado + '&meuindex=' + this.indexBusca;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getPacientes(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        if(this.indexBusca != 0){
          console.log("somar");
          var testX = [];
          this.arrResults = this.arrResults.concat(qRes['objResultado']);
        }
        else{
          console.log("first time");
          this.arrResults = qRes['objResultado'];
          //this.arrResults = Object.assign([], qRes['objResultado']);

        }
        
        console.log(this.arrResults);
        this.qtdResultados = qRes['qtdTotal'];

        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";

        if(this.arrResults.length < this.qtdResultados){
          this.onDemand = true;
          this.indexBusca = this.arrResults.length;
          this.fraseExib = 'Exibindo <b>' + this.arrResults.length + '</b> de <b>' + this.qtdResultados + '</b> resultados encontrados';
        }
        else{
          this.fraseExib = 'Encontramos <b>' + this.arrResults.length + '</b> pacientes cadastrados';
          this.onDemand = false;
        }

        this.arrResults.forEach(element => {
          element.dataf =  moment(element.datarel).format('DD/MM/YYYY');
        });
      }
    })
  }

  obterResultadosP() :void{
    this.hideCL = false;
    //this.tipoListar = 'listar';
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipopesquisa=listar&parametro=' + this.qBuscado + '&meuindex=' + this.indexBusca;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getPacientes(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        if(this.indexBusca != 0){
          console.log("somar");
          var testX = [];
          this.arrResults = this.arrResults.concat(qRes['objResultado']);
        }
        else{
          console.log("first time");
          this.arrResults = qRes['objResultado'];
          //this.arrResults = Object.assign([], qRes['objResultado']);

        }
        
        console.log(this.arrResults);
        this.qtdResultados = qRes['qtdTotal'];

        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";

        if(this.arrResults.length < this.qtdResultados){
          this.onDemand = true;
          this.indexBusca = this.arrResults.length;
          this.fraseExib = 'Exibindo <b class="res_b">' + this.arrResults.length + '</b> de <b class="res_b">' + this.qtdResultados + '</b> resultados encontrados para <b>' + this.qBuscado + '</b>';
        }
        else{
          this.fraseExib = 'Encontramos <b class="res_b">' + this.arrResults.length + '</b> resultados para <b class="res_b">' + this.qBuscado + '</b>';
          this.onDemand = false;
        }

        this.arrResults.forEach(element => {
          element.dataf =  moment(element.datarel).format('DD/MM/YYYY');
        });
      }
    })
  }

  pesquisarPaciente()  :void{
    const addNT = this.dialog.open(AlertaInputDialog, {
      width: '250px',
      disableClose: true,
      data: {iconAlerta: "", textoInput: 'Nome', tipoInput: 'text', nomeInput: 'nome',  tituloAlerta: 'Pesquisar', textoAlerta: 'Digite o nome do paciente', textoCancel: 'Cancelar', textoConfirm: "OK"}
    });
    addNT.afterClosed().subscribe(result =>{
      console.log(result);
      if(result !== false && result !== undefined){
        //server side
        if(result.length <= 3){
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Digite pelo menos 4 caracteres para realizar a busca", iconAlerta: 'warning'}
          });
        }
        else{
          this.indexBusca = 0;
          this.router.navigate(['/dashboard/pacientes/listar/' + result]);
        }
        //alterar route
        // this.qBuscado = result;
        // this.indexBusca = 0;
        // this.obterResultadosP();

      }
    })
  }

  exibirAll() :void{
    this.indexBusca = 0;
    this.router.navigate(['/dashboard/pacientes/all/all']);
  }
  novaPesquisa() :void{
    this.router.navigate(['/pesquisando/pessoas']);
  }
  
  goPerfil(nomeusuario: any) :void{
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/dashboard/paciente/' + nomeusuario]);
  }

  voltar() :void{
    this.router.navigate(['/dashboard/home']);
  }
}
